import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, UserHttpService, MeetingGroupDetail, AddMeeting, CommonWebService, MeetingList, MeetingDetail, AcceptMeeting, DeclineMeeting, RescheduleMeeting, CancelMeeting } from "../public-api";

@Injectable({
  providedIn: "root",
})
export class MeetingServiceHttp {

  constructor(
    private http: HttpClient,
    private userSessionService: UserHttpService,
    private commonService: CommonWebService
  ) {}


  //group list
  getGroupList(): Observable<HttpResponse<MeetingGroupDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id",this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<MeetingGroupDetail[]>>("meeting/groupList", formData);
  }

  //meeting list
  getMeetingList(): Observable<HttpResponse<MeetingList[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id",this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<MeetingList[]>>("meeting/meetingList", formData);
  }

  //add meeting
  addMeeting(body: AddMeeting): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id",this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("meeeing_title", body.meeting_title ? body.meeting_title : "");
    formData.append("meeting_date", body.meeting_date ? this.commonService.changeDateFormat(body.meeting_date as Date) : "");
    formData.append("meeting_time", body.meeting_time ? body.meeting_time : "");
    formData.append("meeeing_timeZone", body.meeting_timeZone ? body.meeting_timeZone : "");
    formData.append("meeeing_recurring", body.meeting_recurring ? "1" : "0");
    formData.append("zoom_meeting_check", body.zoom_meeting_check ? "1" : "0");
    formData.append("zoom_link", body.zoom_link ? body.zoom_link : "");
    formData.append("meeeing_priority", body.meeting_priority ? body.meeting_priority : "");
    formData.append("userFullname", body.userFullname ? body.userFullname : "");

    if(body.users_ids && body.users_ids.length > 0) {
      body.users_ids.forEach((X, i) => {
        formData.append(`users_ids[${i}]`, X.user_id ? X.user_id : "");
      })
    };

    if(body.client_ids && body.client_ids.length > 0) {
      body.client_ids.forEach((X, i) => {
        formData.append(`client_ids[${i}]`, X.client_id ? X.client_id : "");
      })
    };

    if(body.group_ids && body.group_ids.length > 0) {
      body.group_ids.forEach((X, i) => {
        formData.append(`group_ids[${i}]`, X.group_id ? X.group_id : "");
      })
    };

    return this.http.post<HttpResponse<{group_id: string; group_name: string}[]>>("meeting/createMeeting", formData);
  }

  getMeetingDetail(id: string): Observable<HttpResponse<MeetingDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id",this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("meeting_id", id ? id : "");
    return this.http.post<HttpResponse<MeetingDetail[]>>('meeting/meetingDetail', formData);
  }

  acceptMeeting(body: AcceptMeeting): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id",this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("meeting_id", body.meeting_id ? body.meeting_id : "");
    formData.append("meeting_status", body.meeting_status ? body.meeting_status : "");
    formData.append("user_name", body.usr_fullName ? body.usr_fullName : "");
    formData.append("meeting_sender_emailid", body.meeting_sender_emailid ? body.meeting_sender_emailid : "");
    formData.append("meeting_date", body.meeting_date ? this.commonService.changeDateFormat(body.meeting_date as Date) : "");
    formData.append("meeting_time", body.meeting_time ? body.meeting_time : "");
    return this.http.post<HttpResponse<any>>('meeting/meetingRevert', formData);
  }

  declineMeeting(body: DeclineMeeting): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id",this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("meeting_id", body.meeting_id ? body.meeting_id : "");
    formData.append("meeting_status", body.meeting_status ? body.meeting_status : "");
    formData.append("meeting_sender_emailid", body.meeting_sender_emailid ? body.meeting_sender_emailid : "");
    formData.append("meeting_date", body.meeting_date ? this.commonService.changeDateFormat(body.meeting_date as Date) : "");
    formData.append("user_name", body.usr_fullName ? body.usr_fullName : "");
    formData.append("meeting_time", body.meeting_time ? body.meeting_time : "");
    formData.append("meeting_decline_Reason", body.meeting_decline_Reason ? body.meeting_decline_Reason : "");
    return this.http.post<HttpResponse<any>>('meeting/meetingRevert', formData);
  }

  rescheduleMeeting(body: RescheduleMeeting): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id",this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("meeting_id", body.meeting_id ? body.meeting_id : "");
    formData.append("user_name", body.usr_fullName ? body.usr_fullName : "");
    formData.append("meeting_status", body.meeting_status ? body.meeting_status : "");
    formData.append("meeting_date", body.meeting_date ? this.commonService.changeDateFormat(body.meeting_date as Date) : "");
    formData.append("meeting_time", body.meeting_time ? body.meeting_time : "");
    formData.append("meeting_sender_emailid", body.meeting_sender_emailid ? body.meeting_sender_emailid : "");
    formData.append("meeting_reschedule_date", body.meeting_reschedule_date ? this.commonService.changeDateFormat(body.meeting_reschedule_date as Date) : "");
    formData.append("meeting_reschedule_time", body.meeting_reschedule_time ? body.meeting_reschedule_time : "");
    formData.append("meeting_reschedule_timezone", body.meeting_reschedule_timezone ? body.meeting_reschedule_timezone : "");
    return this.http.post<HttpResponse<any>>('meeting/meetingRevert', formData);
  }

  cancelMeeting(body: CancelMeeting): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id",this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("meeting_id", body.meeting_id ? body.meeting_id : "");
    formData.append("user_name", body.usr_fullName ? body.usr_fullName : "");
    formData.append("meeting_date", body.meeting_date ? this.commonService.changeDateFormat(body.meeting_date as Date) : "");
    formData.append("meeting_time", body.meeting_time ? body.meeting_time : "");
    formData.append("meeting_status", body.meeting_status ? body.meeting_status : "")
    return this.http.post<HttpResponse<any>>('meeting/cancelMeeting', formData);
  }
}
